import { PLATFORM, PLATFORM_IS_NATIVE } from "src/hybrid/components/Platform";

export function isPlatform(platform: typeof PLATFORM): boolean {
  return PLATFORM === platform;
}

export function isAndroid(): boolean {
  return isPlatform("android");
}

export function isIOS(): boolean {
  return isPlatform("ios");
}

export function isHybridApp(): boolean {
  return PLATFORM_IS_NATIVE && (isAndroid() || isIOS());
}

export function isAndroidDevice(): boolean {
  const useragent = navigator.userAgent.toLowerCase();
  return /android/.test(useragent);
}

/** iPadOS Safari reports itself as a Mac, so a touch-capable "Mac" counts too. */
export function isIOSDevice(): boolean {
  const useragent = navigator.userAgent.toLowerCase();
  return (
    /iphone|ipad|ipod/.test(useragent) ||
    (/macintosh/.test(useragent) && navigator.maxTouchPoints > 1)
  );
}
